var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 8.41035C8.08136 8.41035 8.77778 7.70687 8.77778 6.83903C8.77778 5.97121 8.08136 5.2677 7.22222 5.2677C6.36309 5.2677 5.66667 5.97121 5.66667 6.83903C5.66667 7.70687 6.36309 8.41035 7.22222 8.41035ZM7.22222 8.41035V10.7673M13.4444 8.01752C13.4444 11.5224 9.19778 14.0622 7.72109 14.8394C7.56141 14.9235 7.48153 14.9655 7.37078 14.9873C7.28444 15.0042 7.16 15.0042 7.07367 14.9873C6.96291 14.9655 6.88303 14.9235 6.72336 14.8394C5.24664 14.0622 1 11.5224 1 8.01752V5.04583C1 4.41769 1 4.10362 1.1017 3.83364C1.19154 3.59514 1.33754 3.38234 1.52707 3.21362C1.74161 3.02263 2.03273 2.91236 2.61498 2.6918L6.78527 1.11209C6.94697 1.05084 7.02778 1.02022 7.111 1.00807C7.18473 0.997309 7.25971 0.997309 7.33344 1.00807C7.41667 1.02022 7.49748 1.05084 7.65918 1.11209L11.8295 2.6918C12.4117 2.91236 12.7028 3.02263 12.9173 3.21362C13.1069 3.38234 13.2529 3.59514 13.3427 3.83364C13.4444 4.10362 13.4444 4.41769 13.4444 5.04583V8.01752Z",
    stroke: "#6B92FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.7fc36c41.svg";
export { ForwardRef as ReactComponent };